module.exports = __webpack_public_path__ + "img/collection-engagementRingsGold.953edda.webp";